import React from "react";
import Dialog from "@mui/material/Dialog";
import { IoMdClose } from "react-icons/io";
import IconButton from "../IconButton/IconButton";
import "./Modal.css";

/**
 * Design-system Modal — wraps MUI Dialog (focus trap, backdrop, a11y)
 * with the Savills 2026 chrome: 12px radius, bordered header/footer.
 *
 * @param {boolean} open
 * @param {function} onClose
 * @param {React.ReactNode} title    header text (optional)
 * @param {React.ReactNode} actions  footer buttons (optional)
 * @param {"sm"|"md"} size           420px | 600px max width
 */
const Modal = ({ open, onClose, title, actions, size = "md", children, ...rest }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      className="kc-modal"
      maxWidth={false}
      PaperProps={{ sx: { maxWidth: size === "sm" ? 420 : 600 } }}
      {...rest}
    >
      {(title || onClose) && (
        <div className="kc-modal__header">
          {title ? <h3 className="kc-modal__title">{title}</h3> : <span />}
          {onClose && (
            <IconButton label="Close" size="md" onClick={onClose}>
              <IoMdClose />
            </IconButton>
          )}
        </div>
      )}
      <div className="kc-modal__body">{children}</div>
      {actions && <div className="kc-modal__footer">{actions}</div>}
    </Dialog>
  );
};

export default Modal;
